<template>
  <el-drawer
    title="个人信息"
    :visible="props.drawer"
    :direction="'rtl'"
    :before-close="handleClose"
  >
    <div class="form-data">
      <el-form ref="form" v-model="form" label-width="80px">
        <el-form-item label="邮箱:">
          {{ email }}
          <span class="zxzh" @click="deleteUser(email)">注销账号</span>
        </el-form-item>
        <el-form-item label="昵称:">
          <el-input
            maxlength="20"
            show-word-limit
            v-model="username"
            style="width: 100%"
            placeholder="填写您的昵称"
          />
        </el-form-item>
        <!-- <el-form-item label="工作单位:">
          <el-input
            maxlength="50"
            show-word-limit
            v-model="workunit"
            style="width: 100%"
            placeholder="填写您的工作单位"
          />
        </el-form-item>
        <el-form-item label="电话:">
          <el-input
            maxlength="11"
            show-word-limit
            v-model="mobile"
            style="width: 100%"
            placeholder="填写您的电话"
          />
        </el-form-item>
        <el-form-item label="QQ:">
          <el-input
            maxlength="20"
            show-word-limit
            v-model="qq"
            style="width: 100%"
            placeholder="填写您的QQ号码"
          />
        </el-form-item>
        <el-form-item label="微信:">
          <el-input
            maxlength="20"
            show-word-limit
            v-model="wechat"
            style="width: 100%"
            placeholder="填写您的微信号码"
          />
        </el-form-item> -->
      </el-form>
    </div>
    <div class="form-button">
      <el-button size="mini" @click="submit" type="primary">修改</el-button>
      <el-button size="mini" @click="handleClose">取消</el-button>
    </div>
    <el-dialog title="注销账户" append-to-body :visible.sync="dialogFormVisible" width="500px">
        <p>
            <strong>
              在您申请注销账号之前，请您认真阅读、理解并同意《水质荧光指纹污染溯源平台注销协议》（以下简称“注销协议”），当您按照注销流程进行操作开始，均视为您已同意和遵守本协议的全部内容：
            </strong>
        </p>
        <p>
            <strong>
              1、帐号注销后将无法继续使用该帐号进行登录；</strong>
        </p>
        <p>
            <strong>
              2、注销账号为不可恢复的操作，注销账号后您将无法再通过该账号上传、下载任何信息；</strong>
        </p>
        <p>
            <strong>
              3、建议您在注销前自行备份当前账号下全部信息，并请确认与当前账号相关的所有服务信息等均已进行妥善处置；</strong>
        </p>
        <p>
            <strong>
              4、注销成功后，账号个人信息和个人数据将被全部清除，且不可恢复。</strong>
        </p>
      <div class="input-wrap">
        <div class="input-box">
          <span>邮箱</span>
          <span>{{ email }}</span>
        </div>
      </div>
      <div class="input-wrap">
        <div class="input-box-2">
          <span>验证码<b>*</b></span>
          <input
            type="text"
            v-model="code"
            placeholder="请输入验证码"
            required
          />
          <span v-if="!sendFlag" @click="getCode">{{ message }}</span>
          <span class="wait-30s" v-if="sendFlag">{{ message }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteUserSubmit"
          >确定注销</el-button
        >
      </div>
    </el-dialog>
  </el-drawer>
</template>
<script setup>
import { defineProps, ref, defineEmits, watch } from "vue";
import { MessageBox, Message } from "element-ui";
import api from "@/api/login";
const emit = defineEmits(["closeBox"]);
const props = defineProps({
  drawer: Boolean,
  userInfoData: Object,
});

const form = ref({});
const username = ref("");
const workunit = ref("");
const email = ref("");
const mobile = ref("");
const qq = ref("");
const wechat = ref("");
const message = ref("获取验证码");
const sendFlag = ref(false);
const code = ref("");
const dialogFormVisible = ref(false);
const sendCodeInset = ref(null);
// props
const handleClose = (type=null) => {
  emit("closeBox",type);
};

const deleteUser = () => {
    dialogFormVisible.value = true;
};

const deleteUserSubmit = () => {
    MessageBox.confirm("请确认，注销账号后您将无法再通过此账号登录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        
        api.clearAccount({
          code: code.value
        }).then(res=> {
          if(res.code === 0) {
            Message({
              message: "注销成功",
              type: "success",
            });
            dialogFormVisible.value = false;
            handleClose('delUser')
          } else {
            Message({
              message: res.msg,
              type: "error",
            });
          }
        }).catch(res=> {
          Message({
              message: res.msg,
              type: "error",
            });
        })
    });
}
const getCode = () => {
      // 验证是否为邮箱
      sendFlag.value = true;
      let num = 60;
      sendCodeInset.value = setInterval(() => {
        num--;
        message.value = num + "秒后重新" + "获取验证码";
        if (num <= 0) {
          clearInterval(sendCodeInset.value);
          message.value = "获取验证码";
          sendCodeInset.value = undefined;
          sendFlag.value = false;
        }
      }, 1000);
      api
        .sendClearAccountCode({
          email: email.value,
        })
        .then((res) => {
          if (res.code === 0) {
            Message({
              message: "验证码已发送致邮箱[" + email.value + "]，请注意查收",
              type: "success",
            });
          } else {
            Message({
              message: res.msg,
              type: "error",
            });
          }
        });
}
const submit = () => {
  MessageBox.confirm("确认要修改个人信息吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      api
        .updateUserInfo({
          username: username.value,
          workunit: workunit.value,
          email: email.value,
          mobile: mobile.value,
          qq: qq.value,
          wechat: wechat.value,
        })
        .then((res) => {
          if (res.code === 0) {
            sessionStorage.setItem("name", username.value);
            Message({
              message: "修改成功",
              type: "success",
            });
            handleClose();
          } else {
            Message({
              message: res.msg,
              type: "error",
            });
          }
        });
    })
    .catch(() => {
      Message({
        message: "已取消",
      });
    });
};
watch(
  () => props.userInfoData,
  (newValue) => {
    username.value = newValue.username;
    workunit.value = newValue.workunit;
    email.value = newValue.email;
    mobile.value = newValue.mobile;
    qq.value = newValue.qq;
    wechat.value = newValue.wechat;
  }
);
</script>
<style lang="scss" scoped>
.form-data {
  border-top: 1px solid #e7e7e7;
  height: calc(100% - 66px);
  padding: 20px 30px;

  .zxzh {
    float: right;
    cursor: pointer;
    color: #00a8ff;
  }
}
.form-button {
  border-top: 1px solid #e7e7e7;
  height: 66px;
  display: flex;
  align-items: center;
  padding-left: 16px;
}

.input-wrap {
      margin-top: 10px;

      b {
        color: red;
        margin-left: 5px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: sub;
      }

      i {
        font-size: 12px;
        color: #999;

        &.red {
          color: red;
        }
        &.green {
          color: green;
        }
      }

      

      span {
        font-size: 16px;
        color: #999;
      }

      .input-box {
        margin-top: 30px;
        display: flex;
        span {
            display: inline-block;
            text-align: center;

            &:first-of-type {
                flex: 1;
            }
          &:last-of-type {
            flex: 2;
            text-align: left;
          }
        }
      }

      .input-box-2 {
        margin-top: 30px;
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          flex: 1;
          text-align: center;
          &:first-of-type {
            flex: 1;
          }
          &:last-of-type {
            color: #124fff;
            cursor: pointer;
            flex: 1;

            &.wait-30s {
              color: #999;
              cursor: default;
            }
          }
        }
        input {
          display: inline-block;
          font-size: 16px;
          padding: 10px 20px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
          width: 200px;
        }
      }
    }
</style>